import type { LeadConsentFormFields } from './lead-consent-form.interface';

export const LeadConsentFormDefaults: {
  fields: { [Key in keyof LeadConsentFormFields]: string };
} = {
  fields: {
    AllowDataUsageLabel:
      'De aanvraag voor een adviesgesprek zal door de servicepartners van Essent worden verwerkt. ' +
      'Daarom worden gegevens die nodig zijn voor het behandelen van de aanvraag doorgegeven aan de servicepartner.',
    AllowDataUsageRequiredError:
      'Toestemming tot gegevensverwerking is verplicht',
    AllowPromotionalUpdatesLabel:
      'Ik wil graag per e-mail op de hoogte blijven van interessante aanbiedingen en acties van Essent.',
  },
};
